export const ATTENTION_ALERTS_LIMIT = 5;

/** The status strip and attention card read the newest alerts from a single page. */
export const ALERTS_PAGE = 1;
export const ALERTS_PAGE_SIZE = 20;

/** The two failures the pause endpoint documents; anything else gets a generic message. */
export const PAUSE_ERROR_KEY: Readonly<Record<number, string>> = {
	403: 'ERROR_FORBIDDEN',
	422: 'ERROR_REASON_REQUIRED',
};

export const DEFAULT_PAUSE_ERROR_KEY = 'ERROR_GENERIC';

export const PAUSE_REASON_MIN_LENGTH = 1;
export const PAUSE_REASON_MAX_LENGTH = 280;

export const PAUSE_REASON_FIELD_ID = 'pause-control-reason';
